module.exports = __webpack_public_path__ + "img/introduction_size_two@2x.9384628a.png";